import { render, staticRenderFns } from "./CreateGroup.vue?vue&type=template&id=413448d2&scoped=true"
import script from "./CreateGroup.vue?vue&type=script&lang=ts"
export * from "./CreateGroup.vue?vue&type=script&lang=ts"
import style0 from "./CreateGroup.vue?vue&type=style&index=0&id=413448d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413448d2",
  null
  
)

export default component.exports